import { Constants } from "../constants";
import Web3 from "web3";
import { useEffect, useState } from "react";
import BigNumber from "bignumber.js";

export const useDatachainXdcPay = () => {
    const [txId, setTxId] = useState();
    const [isXdcPayAvailable, setIsXdcPayAvailable] = useState<undefined | boolean>();

    useEffect(() => {
        initXdcPay();
    });

    const getAddress = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const accounts = await window.xdc.enable();
        return accounts[0];
    };

    const addDcErc20Token = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await window.xdc.sendAsync(
            {
                method: "metamask_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: Constants.contractAddress.xdc.erc20.datachain.address,
                        decimals: Constants.contractAddress.xdc.erc20.datachain.decimals,
                        symbol: Constants.contractAddress.xdc.erc20.datachain.symbol,
                        image: Constants.contractAddress.xdc.erc20.datachain.image
                    }
                }
            },
            (err: any, network: any) => {
                console.log(err);
                console.log(network);
            }
        );
    };

    const sendTransaction = async (amount: number, receiveAddress: string) => {
        const account = await getAddress();
        const { contract } = await initWeb3();
        const abi = contract.methods
            .transfer(receiveAddress.replace("xdc", "0x"), Web3.utils.toBN(amount * 10 ** 18))
            .encodeABI();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await window.xdc.sendAsync(
            {
                method: "eth_sendTransaction",
                params: [
                    {
                        from: account,
                        to: Constants.contractAddress.xdc.erc20.datachain.address,
                        data: abi
                    }
                ]
            },
            (err: any, result: any) => {
                console.log(err);
                console.log(result);
                setTxId(result.result);
            }
        );
    };

    const getTokenBalance = async () => {
        const address = await getAddress();
        const { web3, contract } = await initWeb3();

        const result = await contract.methods.balanceOf(address).call();
        return new BigNumber(web3.utils.fromWei(result));
    };

    const initWeb3 = async () => {
        const web3 = new Web3(Constants.contractAddress.xdc.provider);
        const contract = new web3.eth.Contract(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Constants.contractAddress.xdc.erc20.datachain.tokenABI,
            Constants.contractAddress.xdc.erc20.datachain.address
        );
        return { web3, contract };
    };

    const pay = async (amount: string, rate: number, receiveAddress: string) => {
        const amountWithoutDecimals = getAmountWithoutDecimals(amount, rate);
        const balance = await getTokenBalance();
        if (balance.gte(amountWithoutDecimals)) {
            await sendTransaction(Number(amountWithoutDecimals), receiveAddress);
            return {
                status: "success",
                message: "OK"
            };
        } else {
            return {
                status: "error",
                message: `You dont have enough XDC tokens on your account. On your account you have ${balance.toFixed(
                    0,
                    2
                )} but you want to pay ${amountWithoutDecimals}.`
            };
        }
    };

    const getAmountWithoutDecimals = (amount: string, rate: number) => {
        return new BigNumber(amount).div(rate).toFixed(0, 2);
    };

    const checkXdcAvailable = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!window?.xdc) {
            setIsXdcPayAvailable(false);
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const accounts = await window.xdc.enable();
        return setIsXdcPayAvailable(accounts.length > 0);
    };

    const initXdcPay = async () => {
        setInterval(async () => {
            await checkXdcAvailable();
        }, 1000);
    };

    return { pay, txId, addDcErc20Token, isXdcPayAvailable, getAmountWithoutDecimals };
};
